module.exports = __webpack_public_path__ + "media/site_templates/www.paintersnearme.net.au/images/our_services_3-3cbfe06c800b9423dea0c368d0d44a9f.jpg";